module.exports = __webpack_public_path__ + "static/media/jesusRamirez.39e0a7f5.jpg";